module.exports = __webpack_public_path__ + "media/images/adoption/adoption276-4cce2de4116ba0100ab225184d45bf8a.png";